(function () {
  var STORAGE_KEY = 'dlux-recently-viewed-handles';

  var CART_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>';

  var CHAT_BUBBLE_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-chat-bubble" viewBox="0 0 20 20" aria-hidden="true"><path d="M5.8 10.243a1 1 0 1 1 2 0 1 1 0 0 1-2 0M9.23 10.243a1 1 0 1 1 2 0 1 1 0 0 1-2 0M12.66 10.243a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/><path fill-rule="evenodd" d="m16.645 17.204-.008-.004a19 19 0 0 1-.767-.423c-.645-.367-1.263-.72-1.442-.598a7.472 7.472 0 1 1 2.05-2.082c-.134.202.192.843.533 1.513.147.29.297.584.414.85l.006.014c.193.443.293.808.136.944-.128.136-.488.006-.922-.214m1.614.936c-.38.372-.857.345-1.046.321a2.5 2.5 0 0 1-.626-.181 11 11 0 0 1-1.081-.56l-.132-.074c-.29-.166-.538-.307-.744-.408a8.472 8.472 0 1 1 2.877-2.902l.008.02c.092.22.226.483.385.795l.084.165c.178.353.388.774.516 1.146.063.181.131.42.143.669.01.225-.02.668-.384 1.009"/></svg>';

  var SPINNER_HTML =
    '<span class="loading__spinner hidden dlux-recently-viewed__atc-spinner" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg></span>';

  function readHandles() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function absImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function formatMoney(cents, currencyCode) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    var value = amount / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD',
        currencyDisplay: 'symbol',
      }).format(value);
    } catch (e) {
      return value.toFixed(2);
    }
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, '&#39;');
  }

  function splitInner(visuallyHiddenLabel, visibleLabel, includeSpinner, priceStr, iconSvg) {
    var rightHtml = priceStr
      ? '<span class="dlux-card-atc-split__right">' + escapeHtml(priceStr) + '</span>'
      : '';

    var icon = iconSvg || CART_ICON_SVG;

    return (
      '<span class="dlux-card-atc-split__inner">' +
      '<span class="dlux-card-atc-split__left">' +
      '<span class="visually-hidden">' +
      escapeHtml(visuallyHiddenLabel) +
      '</span>' +
      '<span class="dlux-card-atc-split__icon" aria-hidden="true">' +
      icon +
      (includeSpinner ? SPINNER_HTML : '') +
      '</span>' +
      '<span class="dlux-card-atc-split__label">' +
      escapeHtml(visibleLabel) +
      '</span>' +
      '</span>' +
      rightHtml +
      '</span>'
    );
  }

  function addVariantToCart(variantId, button) {
    if (!button || button.classList.contains('is-loading')) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    var sp = button.querySelector('.loading__spinner');
    if (sp) sp.classList.remove('hidden');

    var cartAddUrl =
      (typeof routes !== 'undefined' && routes.cart_add_url) ||
      (window.routes && window.routes.cart_add_url) ||
      '/cart/add';
    fetch(cartAddUrl, config)
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'dlux-recently-viewed',
              productVariantId: String(variantId),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }
        if (!cart) {
          window.location = '/';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'dlux-recently-viewed',
            productVariantId: String(variantId),
            cartData: response,
          });
        }
        if (typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
        if (sp) sp.classList.add('hidden');
      });
  }

  function productCardHtml(product, currencyCode) {
    var imgSrc = absImageUrl(product.featured_image);
    if (!imgSrc && product.images && product.images.length) {
      imgSrc = absImageUrl(product.images[0]);
    }
    var title = product.title || '';
    var url = product.url || '#';
    var variants = product.variants || [];
    var multi = variants.length > 1;
    var v0 = variants[0];
    var priceCents = product.price != null ? product.price : v0 && v0.price != null ? v0.price : 0;
    var priceStr = formatMoney(priceCents, currencyCode);

    var imgBlock = imgSrc
      ? '<img src="' +
        escapeAttr(imgSrc) +
        '" alt="' +
        escapeAttr(title) +
        '" loading="lazy" width="176" height="176">'
      : '<span class="dlux-recently-viewed__placeholder">No image</span>';

    var atcHtml = '';
    if (multi) {
      atcHtml =
        '<a href="' +
        escapeAttr(url) +
        '" class="quick-add__submit button button--secondary dlux-card-atc-split dlux-card-atc-split--no-price">' +
        splitInner('Choose options', 'Choose options', false) +
        '</a>';
    } else if (v0) {
      if (v0.available) {
        atcHtml =
          '<button type="button" class="quick-add__submit button button--secondary dlux-card-atc-split dlux-card-atc-split--no-price" data-dlux-rv-add data-variant-id="' +
          escapeAttr(String(v0.id)) +
          '">' +
          splitInner('Add to bag', 'Add to bag', true) +
          '</button>';
      } else {
        // DLUX: sold-out cards in Recently Viewed link to the PDP (Klaviyo back-in-stock),
        // matching dlux-card-quick-add-standard.liquid behaviour.
        atcHtml =
          '<a href="' +
          escapeAttr(url) +
          '" class="quick-add__submit button button--secondary dlux-card-atc-split dlux-card-atc-split--no-price dlux-card-notify-link">' +
          splitInner('Email when back in stock', 'Email when back', false, null, CHAT_BUBBLE_ICON_SVG) +
          '</a>';
      }
    }

    return (
      '<div class="dlux-recently-viewed__card-wrap card-wrapper product-card-wrapper underline-links-hover">' +
      '<div class="card card--standard card--media">' +
      '<div class="card__inner ratio">' +
      '<div class="card__media">' +
      '<div class="media media--transparent">' +
      '<a href="' +
      escapeAttr(url) +
      '" class="dlux-recently-viewed__img-link">' +
      imgBlock +
      '</a>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<h3 class="card__heading dlux-recently-viewed__product-title">' +
      '<a href="' +
      escapeAttr(url) +
      '" class="full-unstyled-link">' +
      escapeHtml(title) +
      '</a>' +
      '</h3>' +
      '<div class="card-information dlux-recently-viewed__card-price">' +
      '<span class="price">' +
      escapeHtml(priceStr) +
      '</span>' +
      '</div>' +
      '</div>' +
      '<div class="quick-add no-js-hidden">' +
      atcHtml +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function fetchProduct(root, handle) {
    var base =
      (typeof window !== 'undefined' &&
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      root ||
      '/';
    if (base.slice(-1) !== '/') base += '/';
    var url = base + 'products/' + encodeURIComponent(handle) + '.js';
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('product fetch');
      return r.json();
    });
  }

  function init(rootEl) {
    var root =
      rootEl.getAttribute('data-root-url') || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var currencyCode = rootEl.getAttribute('data-currency-code') || 'USD';
    var current = rootEl.getAttribute('data-current-handle') || '';
    var track = rootEl.querySelector('[data-dlux-recently-viewed-track]');
    if (!track) return;

    // Navigation arrows
    var prevBtn = rootEl.querySelector('[data-dlux-rv-prev]');
    var nextBtn = rootEl.querySelector('[data-dlux-rv-next]');
    var cardWidth = 176;
    var gap = 24;
    var scrollAmount = cardWidth + gap;

    function updateNavButtons() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.classList.toggle('is-hidden', track.scrollLeft <= 0);
      var maxScroll = track.scrollWidth - track.clientWidth;
      nextBtn.classList.toggle('is-hidden', track.scrollLeft >= maxScroll - 1);
    }

    function scrollTrack(direction) {
      var newScrollLeft = track.scrollLeft + direction * scrollAmount;
      track.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        scrollTrack(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        scrollTrack(1);
      });
    }

    track.addEventListener('scroll', updateNavButtons);
    window.addEventListener('resize', updateNavButtons);

    track.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dlux-rv-add]');
      if (!btn || btn.tagName !== 'BUTTON') return;
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      addVariantToCart(vid, btn);
    });

    var handles = readHandles().filter(function (h) {
      return h && h !== current;
    });
    if (handles.length === 0) {
      rootEl.classList.add('dlux-recently-viewed--empty');
      return;
    }

    var fetches = handles.map(function (handle) {
      return fetchProduct(root, handle).catch(function () {
        return null;
      });
    });

    Promise.all(fetches).then(function (products) {
      var html = '';
      for (var i = 0; i < products.length; i++) {
        if (products[i]) html += productCardHtml(products[i], currencyCode);
      }
      if (!html) {
        rootEl.classList.add('dlux-recently-viewed--empty');
        return;
      }
      track.innerHTML = html;
      rootEl.classList.remove('dlux-recently-viewed--empty');
      // Update nav buttons after products load
      setTimeout(updateNavButtons, 0);
    });
  }

  function boot() {
    document.querySelectorAll('[data-dlux-recently-viewed]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
